import { useContext } from 'react'
import { UnreadMessagesContext } from '../../providers/UnreadMessagesProvider'

export default function useUnreadMessages() {
  const context = useContext(UnreadMessagesContext)
  if (!context) {
    throw new Error('useUnreadMessages must be used within an UnreadMessagesProvider')
  }

  return context
}
